import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TabsContainerComponent } from './tabs-container.component';
import { AssetTrackingTabsDirective } from './tabs-host.directive';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [TabsContainerComponent, AssetTrackingTabsDirective],
  exports: [TabsContainerComponent],
})
export class TabsContainerModule {

  static forRoot(): ModuleWithProviders<TabsContainerModule> {
    return {
      ngModule: TabsContainerModule,
    }
  }
}

